import {
  toResponseError,
  type WorkflowSampleMigrationInput,
  type WorkflowSampleMigrationSuccess,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'

export function useMigrateAccountSample(): UpdateHookResponse<
  WorkflowSampleMigrationInput,
  WorkflowSampleMigrationSuccess
> {
  const mutation = useTantalimMutation<WorkflowSampleMigrationInput, WorkflowSampleMigrationSuccess>({
    url: '/account/workflow/migrate/sample',
  })

  async function update(input: WorkflowSampleMigrationInput): Promise<WorkflowSampleMigrationSuccess> {
    try {
      return await mutation.mutateAsync(input)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
